import { WorkbookPage } from '@/components/WorkbookPage';

export const CopyrightPage = () => {
  return (
    <WorkbookPage pageId="copyright" prevPage="title" nextPage="how-to-use">
      <div className="min-h-[60vh] flex flex-col justify-center">
        <div className="text-center mb-16">
          <h1 className="text-2xl font-serif font-bold text-foreground mb-2">
            The Rules of Money Workbook
          </h1>
          <p className="text-muted-foreground italic">
            A Practical Guide for Real Life, Real Income, and Real Growth
          </p>
        </div>
        
        <div className="space-y-8 text-sm text-muted-foreground">
          {/* Copyright */}
          <div className="text-center">
            <p className="font-semibold text-foreground mb-1">© 2026</p>
            <p>All rights reserved.</p>
          </div>
          
          {/* Divider */}
          <div className="flex justify-center">
            <div className="h-px w-24 bg-border" />
          </div>
          
          {/* Educational purposes */}
          <div>
            <p className="font-semibold text-foreground mb-2">Educational Purposes Disclaimer</p>
            <p className="leading-relaxed">
              This workbook is designed for educational and informational purposes only. 
              The content provided is intended to help readers develop better financial habits 
              and understanding. It is not intended to replace professional financial, legal, 
              or tax advice.
            </p>
          </div>
          
          {/* No guarantee */}
          <div>
            <p className="font-semibold text-foreground mb-2">No Guarantee Disclaimer</p>
            <p className="leading-relaxed">
              While the strategies and information presented in this workbook are based on 
              sound financial principles, no guarantee is made regarding specific financial 
              outcomes. Individual results will vary based on personal circumstances, 
              consistency of application, and economic conditions.
            </p>
          </div>
          
          {/* Liability limitation */}
          <div>
            <p className="font-semibold text-foreground mb-2">Limitation of Liability</p>
            <p className="leading-relaxed">
              The author and publisher shall not be held liable for any loss, damage, or 
              negative consequences arising from the use or misuse of information contained 
              in this workbook. Readers are encouraged to consult with qualified financial 
              professionals before making significant financial decisions.
            </p>
          </div>
          
          {/* Professional advice */}
          <div className="bg-secondary/50 rounded-lg p-4">
            <p className="text-xs leading-relaxed">
              <strong>Note:</strong> For specific legal, tax, or investment questions, 
              please consult with a licensed professional in your jurisdiction. This workbook 
              is meant to supplement—not replace—professional guidance.
            </p>
          </div>
        </div>
      </div>
    </WorkbookPage>
  );
};
